import filestack from "filestack-js";

export default class Filepicker {
  /* @ngInject */
  constructor($q, $rootScope) {
    this.filestackClient = filestack.init(process.env.FILESTACK_API_KEY);
    this.$q = $q;
    this.$rootScope = $rootScope;
  }

  uploadSectionImage() {
    return this._uploadImage({});
  }

  async uploadSectionUrlImage(imageUrl) {
    return this.filestackClient.storeURL(imageUrl);
  }

  uploadSectionBase64Image(imageBase64) {
    return this.filestackClient.upload(imageBase64);
  }

  uploadProfileImageV2() {
    return this._uploadImage({ cropForce: true });
  }

  uploadOrganizationImage() {
    return this._uploadImage({ aspectRatio: 4 / 3, cropForce: true });
  }

  uploadOrganizationSignature() {
    return this._uploadImage({ aspectRatio: 4 / 3, cropForce: true });
  }

  async _uploadImage(options = {}) {
    const filestackClientOptions = {
      accept: options.mimetype || ["image/gif", "image/png", "image/jpeg"],
      fromSources: options.fromSources || ["local_file_system", "url", "googledrive", "box"],
      lang: this.$rootScope.organization.appLanguage,
      uploadInBackground: false,
      maxSize: parseInt(process.env.FILESTACK_MAX_SIZE),
      transformations: {
        rotate: options.rotate || true,
        circle: options.circle || true,
        crop: {
          aspectRatio: options.aspectRatio || 1,
          force: options.cropForce || false,
        },
      },
    };

    const response = await this.filestackClient.pick(filestackClientOptions);

    return response.filesUploaded[0];
  }
}
